<template>
  <section>
    <Alerts :success="isSuccess" :error="error" />
    <!-- <section v-if="step === 1">
      <section class="flex mt-10">
        <button class="ml-16 focus:outline-none" @click="$router.go(-1)">
          <img :src="require('@/assets/img/Left-arrow.png')" alt="logo" />
        </button>
        <div class="flex w-full justify-center">
          <img
            :src="require('@/assets/img/fitclas.png')"
            alt="logo"
            class="h-11"
          />
        </div>
      </section>
      <section class="flex mx-60 mt-16">
        <div class="flex flex-col pl-10 pr-6">
          <div class="text-2xl font-semibold">
            Ready to start training on Fitclass? &nbsp;
            <p>Here is the breakdown:</p>
          </div>
          <div class="flex flex-col mt-4">
            <div class="flex items-start mb-10">
              <img
                :src="require('@/assets/img/Pencil.png')"
                alt="trainer image"
                class=""
              />
              <div class="flex flex-col pl-4">
                <div class="font-semibold text-md tracking-wide">
                  Learn what makes a successful class
                </div>
                <div class="text-xs mt-2 w-72 text-gray-800">
                  Nibh quisque suscipit fermentum netus nulla cras porttitor
                  euismod nulla.
                </div>
              </div>
            </div>
            <div class="flex items-start mb-10">
              <img
                :src="require('@/assets/img/Emoji.png')"
                alt="trainer image"
                class=""
              />
              <div class="flex flex-col pl-4">
                <div class="font-semibold text-md tracking-wide">
                  Create Your Trainer's profile
                </div>
                <div class="text-xs mt-2 w-72 text-gray-800">
                  Nibh quisque suscipit fermentum netus nulla cras porttitor
                  euismod nulla.
                </div>
              </div>
            </div>
            <div class="flex items-start mb-10">
              <img
                :src="require('@/assets/img/Party.png')"
                alt="trainer image"
                class=""
              />
              <div class="flex flex-col pl-4">
                <div class="font-semibold text-md tracking-wide">
                  Publish your Class
                </div>
                <div class="text-xs mt-2 w-72 text-gray-800">
                  Nibh quisque suscipit fermentum netus nulla cras porttitor
                  euismod nulla.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="relative">
            <div
              class="z-30 absolute rounded-lg inset-0"
              style="
                background-image: linear-gradient(90deg, #3c3c3c, transparent);
              "
            ></div>
            <img
              :src="require('@/assets/img/trainer-image.webp')"
              alt="trainer image"
              class="object-cover rounded-lg h-80"
              @load="handleImageLoad"
            />
          </div>
        </div>
      </section>
      <div class="flex justify-center">
        <button
          class="bg-green-light text-white py-3 px-24 focus:outline-none font-semibold rounded-lg"
          @click="continueToNextPage"
        >
          Continue
        </button>
      </div>
    </section> -->

    <!-- v-else-if="step === 2" -->
    <section v-if="step === 1" class="flex-col sm:flex md:flex-col tablet:flex-row">
      <BannerLayout
        :bannerImage="bannerImage"
        :bannerHeaderText="bannerHeaderText"
      />
      <section
        class="flex-1 px-4 overflow-auto h-screen items-start flex"
      >
        <section class="lg:mt-20 mt-8 flex-1 pl-0 pr-0 xl:pl-20 xl:pr-20 sm:pl-10 sm:pr-10">
          <p class="md:text-xl2 text-2xl leading-10 font-semibold tracking-tight pb-3">
            Become a trainer
          </p>
          <p class="text-md font-medium text-gray-smoke pb-3">Profile Image</p>
          <div class="flex items-center">
            <img
              v-if="userImagePreview"
              :src="userImagePreview"
              alt="user Image"
              class="rounded-full w-20 h-20 object-cover focus:outline-none"
            />
            <button
              v-else
              class="rounded-full capitalize bg-green-light p-3 text-white font-semibold text-lg w-20 h-20 focus:outline-none"
            >
              {{ firstName }}
            </button>
            <div class="flex flex-col ml-6">
              <span class="text-gray-dark">{{userImagePreview ? 'Change Image' : 'Upload Image'}}</span>
              <input
                type="file"
                class="form-input mt-1 block w-full"
                @change="handleFileChange"
              />
            </div>
          </div>
          <div v-if="showImageMessage" class="text-xs text-red-600">
            *Please update your image
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 mt-6">
            <div class="flex flex-col">
              <label class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1"
                >First name</label
              >
              <input
                type="text"
                name="first name"
                readonly
                class="pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                placeholder="John"
                v-model="firstName"
              />
            </div>
            <div class="flex flex-col mt-6 sm:mt-0">
              <label class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1"
                >Last name</label
              >
              <input
                type="text"
                name="last name"
                readonly
                class="pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                placeholder="Smith"
                v-model="lastName"
              />
            </div>
            <div class="flex flex-col mt-6">
              <label class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1"
                >Email</label
              >
              <input
                type="text"
                name="email"
                readonly
                class="pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                v-model="email"
              />
            </div>
          </div>
          <div class="mt-6">
            <p class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1">About me</p>
            <textarea
              rows="3"
              placeholder="Description"
              v-model="$v.description.$model"
              class="pl-3 w-full pt-2 pb-2 pr-3 border-1 border-borderColor focus:outline-none rounded-md"
              :classStr="{ 'border-red-500': $v.description.$error }"
            ></textarea>
            <div v-if="$v.description.$error">
              <span
                class="text-red-700 text-xs"
                v-if="!$v.description.required"
              >
                Description is required
              </span>
            </div>
          </div>
          <div class="flex mb-6 mt-6">
            <button class="w-1/2 bg-gray-cloud font-semibold py-3 rounded-lg focus:outline-none"
            @click="continueToSignupPage">
              Back
            </button>
            <button
              class="w-1/2 text-white bg-green-light px-3 py-3 rounded-lg font-normal focus:outline-none ml-4"
              @click="continueToLanguagePage"
            >
              Next
            </button>
          </div>
        </section>
      </section>
    </section>

    <section v-else-if="step === 2" class="flex-col sm:flex md:flex-col tablet:flex-row">
      <BannerLayout
        :bannerImage="bannerImage"
        :bannerHeaderText="bannerHeaderText"
      />
      <section
        class="flex-1 px-4 overflow-auto h-screen items-start flex"
      >
        <section class="lg:mt-20 mt-8 flex-1 pl-0 pr-0 xl:pl-20 xl:pr-20 sm:pl-10 sm:pr-10">
          <p class="md:text-xl2 text-2xl leading-10 font-semibold tracking-tight pb-3">
            Become a trainer
          </p>
          <p class="text-md font-medium text-gray-smoke pb-3">
            Select languages
          </p>
          <LanguageInput
            :languagesList="languagesList"
            :languagesData="languagesData"
            :languages="languages"
            :header="false"
            :defLanguage="true"
            :selectedLanguageClass="'bg-gray-cloud px-6 py-2'"
            :languageStyle="'ring-1 ring-gray-400 bg-white w-full'"
            @LanguagesChange="handleLanguagesChange"
            @LanguagesRemove="handleLanguagesRemove"
          />
          <div class="grid grid-cols-2 gap-2 mt-16">
            <button
              class="bg-gray-cloud font-semibold py-3 mt-6 rounded-lg focus:outline-none"
              @click="step = 1"
            >
              Back
            </button>
            <button
              class="text-white bg-green-light font-semibold py-3 mt-6 rounded-lg focus:outline-none"
              @click="continueToCategoryPage"
            >
              Next
            </button>
          </div>
        </section>
      </section>
    </section>

    <section v-else-if="step === 3" class="flex-col sm:flex md:flex-col tablet:flex-row">
      <BannerLayout
        :bannerImage="bannerImage"
        :bannerHeaderText="bannerHeaderText"
      />
      <section
        class="flex-1 px-4 overflow-auto h-screen items-start flex"
      >
        <section class="lg:mt-20 mt-8 flex-1 pl-0 pr-0 xl:pl-20 xl:pr-20 sm:pl-10 sm:pr-10">
          <p class="md:text-xl2 text-2xl leading-10 font-semibold tracking-tight pb-3">
            Become a trainer
          </p>
          <p class="text-md font-medium text-gray-smoke pb-3">
            Select your fitness types
          </p>
          <div class="flex flex-wrap">
            <div v-for="i in categories" :key="i.id" class="pr-2 py-2">
              <button
                class="ring-1 ring-gray-300 p-2 px-4 rounded-3xl font-normal focus:outline-none"
                @click="addToCategory(i)"
                :class="[i.selected ? 'bg-green-light text-white' : '']"
              >
                {{ i.name }}
              </button>
            </div>
          </div>
          <span class="text-red-700 text-xs" v-if="maxCatAllowed">{{ maxCatAllowed }}</span>
          <div class="flex mt-16">
            <button
              class="w-1/2 bg-gray-cloud font-semibold py-4 mt-6 rounded-lg focus:outline-none"
              @click="step = 2"
            >
              Back
            </button>
            <button
              class="w-1/2 text-white bg-green-light font-semibold py-4 mt-6 rounded-lg ml-2 focus:outline-none"
              @click="lastStep"
            >
              Next
            </button>
          </div>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
import CarouselBannerLayout from "@/components/layouts/CarouselBannerLayout.vue";
import BannerLayout from "@/components/layouts/BannerLayout.vue";
import { Alerts } from "@/components/t-components";
import { mapActions, mapGetters } from "vuex";
import store from "@/store";
import LanguageInput from "@/components/t-components/LanguageInput";
import { required, alpha } from "vuelidate/lib/validators";
export default {
  components: {
    BannerLayout,
    CarouselBannerLayout,
    LanguageInput,
    Alerts
  },
  data() {
    return {
      step: 1,
      bannerHeaderText: "Think it's too late to get fit?",
      category: "",
      email: "",
      bannerImage: "Trainer-signup.webp",
      categories: [],
      selectedCategories: [],
      languagesData: [],
      userImage: "",
      userImagePreview: "",
      showImageMessage: false,
      languages: [],
      firstName: null,
      lastName: null,
      description: "",
      maxCatAllowed: null
    };
  },
  validations: {
    description: {
      required,
    },
    languagesData: {
      required,
    },
  },
  computed: {
    ...mapGetters(["languagesList", "categoriesList", "isSuccess", "error"]),
  },
  methods: {
    ...mapActions([
      "register",
      "trainerCompleteSignup",
      "getLanguagesList",
      "getCategoriesList",
      "signupVerification",
      "becomeTrainerDirectly",
      "becomeTrainerFromUser",
      "switchToTrainer",
    ]),

    // continueToNextPage() {
    //   this.step = 2;
    //   store.commit("setIsLoading", true);
    // },

    continueToLanguagePage() {
      if (!this.userImagePreview) {
        this.showImageMessage = true;
        return false;
      }
      this.$v.$touch();
      if (this.$v.description.$error) {
        return false;
      }
      this.step = 2;
    },
    continueToSignupPage(){
      this.$router.go(-1);
    },

    continueToCategoryPage() {
      this.$v.$touch();
      if (this.$v.languagesData.$error) {
        return false;
      }
      this.step = 3;
    },

    handleImageLoad() {
      store.commit("setIsLoading", false);
    },

    async getBase64(file) {
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    addToCategory(category) {
      category.selected = !category.selected;
      const index = this.selectedCategories.findIndex((element) => {
        return element === category.id;
      });
      if (index === -1 && this.selectedCategories && this.selectedCategories.length < 4) {
        this.selectedCategories.push(category.id);
      } else if (this.selectedCategories && this.selectedCategories.length === 4 && !this.selectedCategories.includes(category.id)) {
        this.maxCatAllowed = 'Maximum 4 categories allowed'
        category.selected = !category.selected;
      } else {
        this.selectedCategories.splice(index, 1);
        this.maxCatAllowed ? this.maxCatAllowed = '' : ''
      }
    },

    handleLanguagesChange(event) {
      const data = {
        id: event.target.value,
        text: event.target.options[event.target.options.selectedIndex].text,
      };
      if (data.id == "") {
        return;
      }
      const index = this.languagesData.findIndex((e) => e.id === data.id);
      if (index === -1) {
        this.languagesData.push(data);
        this.languages = data.id;
      }
    },

    handleLanguagesRemove(id) {
      const index = this.languagesData.findIndex((e) => e.id === id);
      if (index !== -1) {
        this.languagesData.splice(index, 1);
        this.languages = this.languagesData[0].id;
      }
    },

    handleFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      var imageType = ["image/jpeg", "image/png"];
      var included = imageType.includes(files[0]["type"]);
      if (!included) {
        alert("File should be jpeg and png.");
        return;
      }
      this.userImage = files[0];
      this.getBase64(this.userImage).then(
        (data) => (this.userImagePreview = data)
      );
      this.showImageMessage = false;
    },

    async lastStep() {
      store.commit("setIsLoading", true);

      let data = new FormData();
      data.append("description", this.description);
      data.append("categories", this.selectedCategories);
      // data.append("languages", this.languagesData);
      this.userImage ? data.append("thumbnail_image", this.userImage) : ''
      let languages = [];
      for (var i = 0; i < this.languagesData.length; i++) {
        languages.push(this.languagesData[i].id);
      }
      data.append("languages", languages);

      if (this.getUser().user_type === 1) {
        await this.becomeTrainerFromUser(data).then(async (response) => {
          const userImage = response && response.personal_details && response.personal_details.thumbnail_url
          let details = JSON.parse(localStorage.getItem("details"));
          if (details) {
            details.thumbnail_url = userImage;
            localStorage.setItem("details", JSON.stringify(details));
          }
          await this.switchToTrainer();
        })
      } else {
        await this.becomeTrainerDirectly(data);
      }
      this.$router.push({ name: "dashboard" });
      store.commit("setIsLoading", false);
    },
  },
  async created() {
    // store.commit("setIsLoading", true);
    if (this.getUser()) {
      this.email = this.getUser().email;
      const details = this.getUser('details')
      if (details && Object.keys(details).length) {
        this.firstName = details.f_name;
        this.lastName = details.l_name;
        this.userImagePreview = details.thumbnail_url
      }
    }
    await this.getLanguagesList();
    const languages = [];
    this.languagesList.map((lan) => {
      languages.push({ name: lan.language, id: lan.id });
    });
    this.languages = languages;
    await this.getCategoriesList();
    const categories = [];
    this.categoriesList.map((cat) => {
      categories.push({ name: cat.name, id: cat.id, selected: false });
    });
    this.categories = categories;
  },
};
</script>

<style scoped>
@keyframes transitionFade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.animate-slide-sections {
  animation-name: transitionFade;
  animation-fill-mode: forwards;
  animation-duration: 500ms;
  animation-timing-function: ease-in-out;
}
</style>